function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
// For CommonJS you can use:
// const trkDatatables = require('trk_datatables')(window, $)
// For AMD you can use:
// const trkDatatables = require('trk_datatables')
//
// Main function is:
// trkDatatables.initialise()
(function (factory) {
  "use strict";

  if (typeof define === 'function' && define.amd) {
    // AMD
    define(['jquery'], function ($) {
      return factory($, window, document);
    });
  } else if ((typeof exports === "undefined" ? "undefined" : _typeof(exports)) === 'object') {
    // CommonJS
    module.exports = function (root, $) {
      if (!root) {
        // CommonJS environments without a window global must pass a
        // root. This will give an error otherwise
        root = window;
      }
      if (!$) {
        $ = typeof window !== 'undefined' ?
        // jQuery's factory checks for a global window
        require('jquery') : require('jquery')(root);
      }
      return factory($, root, root.document);
    };
  } else {
    // Browser
    factory(jQuery, window, document);
  }
})(function ($, window, document, undefined) {
  // eslint-disable-line
  "use strict";

  // Sometime when I use: yarn link trk_datatables, than it will load another
  // jquery dependency and Invalidauthenticitytoken is fired. To fix this, you can:
  // $.ajaxPrefilter(function(options, originalOptions, xhr) {
  //   if (!options.crossDomain) {
  //     let token = $('meta[name="csrf-token"]').attr('content');
  //     if (token) xhr.setRequestHeader('X-CSRF-Token', token);
  //   }
  // });
  // On rails side no need to use ProvidePlugin for jquery since we pass it
  // using iif for all our dependencies, but it seems that even it is not
  // loading another dependency of jquery, it needs ProvidePlugin
  //
  // TODO: maybe we should move this require to iife
  // https://github.com/webpack-contrib/imports-loader
  // require("imports-loader?$=jquery!./example.js");
  // require('datatables.net?')(window, $)
  require('imports-loader?define=>false,this=>window!datatables.net')(window, $);
  require('imports-loader?define=>false,this=>window!datatables.net-bs4')(window, $);
  require('datatables.net-bs4/css/dataTables.bootstrap4.css');
  require('./main.sass');
  require('../fontello/css/fontello.css');
  var addColumnSearchInputs = require('./addColumnSearchInputs');
  var addEventListeners = require('./addEventListeners');
  var initialise = function initialise() {
    var passedOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    // ignore .dataTable (duplicate table element with class dataTable is
    // generated by datatables) to avoid duplicate tables on back button
    $('[data-datatable]:not(.dataTable)').each(function () {
      initialiseOne($(this), {
        passedOptions: passedOptions
      });
    });
  };
  var initialiseOne = function initialiseOne($table, _ref) {
    var _ref$isColumnSearch = _ref.isColumnSearch,
      isColumnSearch = _ref$isColumnSearch === void 0 ? undefined : _ref$isColumnSearch,
      _ref$passedOptions = _ref.passedOptions,
      passedOptions = _ref$passedOptions === void 0 ? {} : _ref$passedOptions;
    // when we toggle collumnsearch we need to destroy before addColumnSearchInputs
    $table.DataTable().destroy();
    var options = findOptions($table, passedOptions);
    if (isColumnSearch === undefined) isColumnSearch = $('[data-datatable-search-value][data-datatable-search-value!=""]', $table).length;
    if (isColumnSearch) {
      addColumnSearchInputs($table, passedOptions);
    } else {
      addLabels($table);
    }

    // here we actually initialise Datatable
    var datatable = $table.DataTable(options);
    if ($table.data('datatableAjaxUrl')) {
      // this is serverside table so we can saveLength and saveOrder on server
    } else {
      // for client side we will use another ajax to save preferences
      saveLength($table);
      saveOrder($table);
    }
    if (isColumnSearch) addEventListeners(datatable, options);
    // **adjust** fix https://datatables.net/forums/discussion/43912
    setTimeout(function () {
      datatable.columns.adjust();
    }, 0);
    addIconGlobalSearch($table, isColumnSearch, passedOptions);
  };
  function findOptions($table, passedOptions) {
    var dom = $table.data('datatableDom') || '<"trk-global-search-wrapper"f>rtp<"trk-move-up"il>';
    var order = $table.data('datatableOrder') || [[0, 'desc']];
    var pageLength = $table.data('datatablePageLength') || 10;
    var options = {
      // scrollY: "55vh", do not use Y scroll and show all items on a page
      scrollX: true,
      // this will introduce some misallignment between header and columns
      autoWidth: false,
      // with this option, body is full with but header stays original
      // so we need to use fix for **adjust** (note that if bootstrap styles is
      // loaded using spockets, header has 100% width)
      scrollCollapse: true,
      dom: dom,
      order: order,
      pageLength: pageLength,
      destroy: true // this is needed when we enable/disable column search
    };

    var optionsAjax = {};
    if ($table.data('datatableAjaxUrl')) {
      var ajaxUrl = $table.data('datatableAjaxUrl');
      var totalLength = $table.data('datatableTotalLength');
      optionsAjax = {
        searchDelay: 500,
        processing: true,
        serverSide: true,
        deferLoading: totalLength,
        ajax: {
          url: ajaxUrl,
          type: 'POST',
          error: function error(xhr, message, _error) {
            var msg = "Ajax error. Please refresh the page. ".concat(_error, ".");
            if (typeof xhr != 'undefined' && typeof xhr.responseJSON != 'undefined') {
              msg += " ".concat(xhr.responseJSON['error']);
            }
            flash_alert(msg);
          }
        }
      };
    }
    var optionsColumnDefs = {};
    $('thead th', $table).each(function (index) {
      if ($(this).data('datatableHiddenColumn')) {
        if (!optionsColumnDefs["columnDefs"]) optionsColumnDefs["columnDefs"] = [{
          "targets": [],
          visible: false
        }];
        optionsColumnDefs["columnDefs"][0]['targets'].push(index);
      }
    });
    return _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, options), optionsAjax), optionsColumnDefs), passedOptions), {}, {
      language: _objectSpread({
        processing: "<i class=\"demo-icon trk-icon-spinner trk-spin\"\n            style=\"font-size:24px\"></i> Processing..."
      }, passedOptions.language),
      // https://datatables.net/forums/discussion/comment/159119/#Comment_159119
      initComplete: function initComplete() {
        var api = this.api();
        $('.dataTables_filter input').off() // remove default search api call and append delayed
        .on('input', delay(function () {
          // Bind our desired behavior
          console.log("api ".concat($(this).val()));
          api.search($(this).val()).draw();
          return;
        }, 1000)); // Set delay in milliseconds

        function delay(callback, ms) {
          var timer = 0;
          return function () {
            var context = this,
              args = arguments;
            clearTimeout(timer);
            timer = setTimeout(function () {
              callback.apply(context, args);
            }, ms || 0);
          };
        }
      }
    });
  }
  function addLabels($table) {
    $('thead th', $table).each(function () {
      var original_text = $(this).data('original-text');
      if (original_text) $(this).html(original_text);
    });
  }
  function addIconGlobalSearch($table, isColumnSearch, passedOptions) {
    var icon = isColumnSearch ? 'trk-icon-table' : 'trk-icon-grid';
    $('.trk-global-search-wrapper label').append("<div class='trk-global-search-icon-wrapper'><button class='trk-global-search-button'><i class='demo-icon ".concat(icon, "' aria-hidden='true'></i></button></div>"));
    $('.trk-global-search-icon-wrapper').on('click', function () {
      if (isColumnSearch) {
        initialiseOne($table, {
          isColumnSearch: false,
          passedOptions: passedOptions
        });
      } else {
        initialiseOne($table, {
          isColumnSearch: true,
          passedOptions: passedOptions
        });
      }
    });
  }
  function savePreference(data) {
    $.ajax({
      url: '/my-profile/preferences',
      method: 'POST',
      data: {
        preference_name: "datatable_preference",
        preference_value: data
      },
      dataType: "json",
      success: function success(data, status) {
        console.log("data-user-preferences ".concat(status));
      }
    });
  }
  function saveLength(table) {
    table.on('length.dt', function (e, settings, len) {
      var name = $(this).data().datatableName;
      var data = _defineProperty({}, name, {
        page_length: parseInt(len)
      });
      savePreference(data);
    });
  }
  function saveOrder(table) {
    table.on('order.dt', function (e, settings, order) {
      var name = $(this).data().datatableName;
      var direction = order[0].dir;
      var column_index = order[0].col;
      var data = _defineProperty({}, name, {
        direction: direction,
        column_index: column_index
      });
      savePreference(data);
    });
  }
  function flash_alert(msg) {
    alert(msg);
  }
  return {
    initialise: initialise
  };
  // module.exports = { initialise }
});